export declare namespace AppSignatureTokenSections {
	interface Label {
		color: string;
		fontWeight: string;
		fontSize: string;
	}

	interface Canvas {
		background: string;
		borderColor: string;
		borderRadius: string;
		shadow: string;
		height: string;
		hover: {
			borderColor: string;
		};
		focus: {
			borderColor: string;
		};
		filled: {
			background: string;
		};
		disabled: {
			background: string;
			borderColor: string;
		};
		invalid: {
			borderColor: string;
		};
	}

	interface Placeholder {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
		invalid: {
			color: string;
		};
	}

	interface ClearButton {
		color: string;
		hoverBackground: string;
	}
}

export type AppSignatureTokens = {
	gap: string;
	label: AppSignatureTokenSections.Label;
	canvas: AppSignatureTokenSections.Canvas;
	placeholder: AppSignatureTokenSections.Placeholder;
	clearButton: AppSignatureTokenSections.ClearButton;
};

export const label: AppSignatureTokenSections.Label = {
	color: '{form.field.float.label.color}',
	fontWeight: '500',
	fontSize: '{app.sm.font.size}',
};

export const canvas: AppSignatureTokenSections.Canvas = {
	background: '{form.field.background}',
	borderColor: '{surface.100}',
	borderRadius: '{form.field.border.radius}',
	shadow: '0px 1px 2px rgba(18, 18, 23, 0.05)',
	height: '200px',
	hover: {
		borderColor: '{form.field.hover.border.color}',
	},
	focus: {
		borderColor: '{form.field.focus.border.color}',
	},
	filled: {
		background: '{form.field.filled.background}',
	},
	disabled: {
		background: '{form.field.disabled.background}',
		borderColor: '{surface.100}',
	},
	invalid: {
		borderColor: '{form.field.invalid.border.color}',
	},
};

export const placeholder: AppSignatureTokenSections.Placeholder = {
	color: '{surface.200}',
	fontSize: '14px',
	fontWeight: '400',
	lineHeight: '17px',
	invalid: {
		color: '{red.600}',
	},
};

export const clearButton: AppSignatureTokenSections.ClearButton = {
	color: '{red.500}',
	hoverBackground: '{red.50}',
};

/**
 * Signature pad — Figma textarea states (2654:86508) mapped onto the drawing surface.
 * Float-label / sm / lg size matrix skipped: the pad is a canvas, not a text field.
 */
export default {
	gap: '7px',
	label,
	canvas,
	placeholder,
	clearButton,
} satisfies AppSignatureTokens;
